var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('Echart',{attrs:{"options":_vm.options,"id":"CenterTopEchart","height":"600px","width":"100%"}}),_c('dv-decoration-12',{staticStyle:{"width":"150px","height":"150px","position":"absolute","left":"10px","top":"15px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }